export default {
  //先决条件数据接口获取
  getFirstDataUrl: {
    type: String,
    default: '',
  },
  showHandleBtn: {
    // 错误提示 是否显示可跳转 按钮
    type: Boolean,
    default: true,
  },
  // 高级查询表单定义配置Url
  criteriaFormUrl: {
    type: String,
    default: '~static/mock/crud/getCriteriaByCode.json',
  },
  iconSelection: {
    type: Boolean,
    default: true,
  },
  //增加checkbox
  selection: {
    type: Boolean,
    default: false,
  },
  topIconSelectionMultiple: {
    type: Boolean,
    default: true,
  },
  tableColumnDef: {
    type: Array,
    default: () => [],
  },
  tableColumnDefUrl: {
    type: String,
    default: '~static/mock/crud/tableColumnData.json',
  },
  bottomTableColumnDef: {
    type: Array,
    default: () => [],
  },
  bottomTableColumnDefUrl: {
    type: String,
    default: '~static/mock/crud/tableColumnData.json',
  },
  bottomTableOpenValidation: {
    // 下表格是否 可以编辑 控制表格行高度
    type: Boolean,
    default: false,
  },
  //表单url
  formItemsDefUrl: {
    type: String,
    default: '',
  },
  //  自定义操作栏表头名称
  operateCell: {
    type: String,
    default: '操作',
  },
  selectionTableKey: {
    type: String,
    default: '',
  },
  // 是否直接展示删除图标
  isRemoveIcon: {
    type: Boolean,
    default: true,
  },
  // 是否显示 操作按钮列
  operateCellShow: {
    type: Boolean,
    default: true,
  },
  urlQuery: {
    type: String,
    default: '~static/mock/crud/queryAdvance.json',
  },
  urlQueryMethod: {
    type: String,
    default: 'post',
  },
  // 查询地址-参数
  urlQueryParamter: {
    type: Object,
    default: null,
  },
  buttonMenuListUrl: {
    type: String,
    default: '~static/mock/crud/getMenu_OfcrudArray.json?component=pangu-crud-crudEditOfOrder',
  },
  allbuttonMenuListUrl: {
    type: String,
    default: null,
  },
  searchInputOptions: {
    // condition 查询条件 可以配置不同的查询过滤条件
    type: Object,
    default: () => ({
      condition:
        '{{row.target.organization.name.includes(keyWord) || row.number.includes(keyWord)}}',
      placeholder: '关键字',
    }),
  },
  addRowConditionOptions: {
    // 向下表添加数据 满足的条件 满足条件添加，不满足不能添加
    type: Object,
    default: null,
    /* () => ({
            rules:[
                {check:"{{}}",message:'必须相同转入仓库才能添加到任务列表'}
            ] */
  },
  tableTopFormItemDefUrl: {
    // 下表格 头部表单定义接口地址
    type: String,
    default: '',
  },
  getFormDataUrl: {
    // 初始化表单数据 formData 的 URL
    type: String,
    default: '',
  },
  getFormDataParm: {
    // 初始化表单数据 需要的参数
    type: Object,
    default: () => ({}),
  },
  getOrderTransUrl: {
    // 获取订单 表单转化数据接口
    type: String,
    default: '',
  },
  getOrderTransParam: {
    // 转换order数据接口 参数
    type: Object,
    default: () => ({}),
  },
  getOrderTransParamKey: {
    //转换order数据接口 参数默认key
    type: String,
    default: 'parentIds',
  },
  orderIdKey: {
    // 明细行数据，里面获取 上游单据 parentOrderId 的Key
    type: String,
    default: 'parentOrderId',
  },
  itemsKey: {
    type: String,
    default: 'items',
  },
  //是否删除备注
  noteKey: {
    type: Boolean,
    default: false,
  },

  getItemTransUrl: {
    // 向下表，购物车添加数据时，转换数据接口
    type: String,
    default: '',
  },
  getItemTransParam: {
    // 转换数据接口 参数
    type: Object,
    default: () => ({}),
  },
  getItemTransParamDefaultKey: {
    // 转换数据接口 默认参数key
    type: String,
    default: 'ids',
  },
  getItemTransParamDefaultKeyVal: {
    // 转换数据接口 默认参数取值key,没有时将整条明细传给后台
    type: String,
    default: 'id',
  },
  useBackCount: {
    //orderBackCountUtil || priceControlBackCountUtil
    type: String,
    default: '',
  },
  enableMinus: {
    // 是否开启减号 模式
    type: Boolean,
    default: true,
  },
  topItemUniqueKey: {
    // 上表格 与下表 唯一对应的 key
    type: String,
    default: 'id',
  },
  bottomItemUniqueKey: {
    // 下表格 与上表 唯一对应的 key
    type: String,
    default: 'parent',
  },
  specialState: {
    //自定义的store初始状态
    type: Object,
    default: () => ({}),
  },
  specialMutations: {
    //自定义的store初始Mutations
    type: Object,
    default: () => ({}),
  },
  specialActions: {
    //自定义的store初始Actions
    type: Object,
    default: () => ({}),
  },
  initialLoad: {
    //初始是否加载数据
    type: [String, Boolean],
    default: true,
  },
  specialAddItemsCover: {
    // 添加产品时，是否启用覆盖，如果产品相同就覆盖
    type: Boolean,
    default: false,
  },
  asyncOption: {
    type: Boolean,
    default: false,
  },
  //底部表格，顶部下拉选择-匹配的属性名
  rightTopSelectKeysSTable: {
    type: [Array],
    default: () => [],
  },

  //底部表格，顶部下拉选择-下拉值
  rightTopSelectOptionsSTable: {
    type: [Array],
    default: () => [],
  },

  // 是否显示下表格上方的删除按钮
  showRemove: {
    type: Boolean,
    default: true,
  },
  //是否显示下表格上方的清空按钮
  showRemoveAll: {
    type: Boolean,
    default: true,
  },
  //是否将查询参数保存至locaStorage中，保存至localStorage中后每次进入该页面都会取缓存的数据
  saveParamLocalStorage: {
    type: Boolean,
    default: false,
  },
  //*****************需求5606 TOP表格-底部汇总查询*********************** */
  summarySearchOption: {
    type: Object,
    default: null,
  },

  //确认按钮信息
  sureBtn: {
    type: String,
    default: '确定',
  },
  //是否显示扫码
  showScan: {
    type: Boolean,
    default: false,
  },
  //是否显示厂商原始条码扫码
  showScanOrigin: {
    type: Boolean,
    default: false,
  },
  //追溯码扫码url,存在时显示
  traceableCodeUrl: String,
  onScanTraceable: Function,
  //扫码的beforeAction
  scanBeforValueAction: {
    type: Object,
    default: () => {
      return {
        name: 'addDataToShoppingTable',
        type: 'actions',
      }
    },
  },
  //扫码厂家原始条码的beforeAction
  scanOriginBeforValueAction: {
    type: Object,
    default: () => {
      return {
        name: 'addDataByOriginToShoppingTable',
        type: 'actions',
      }
    },
  },
  //扫码查询的接口信息
  scanAsyncGetDataOptions: {
    type: Object,
    default: () => {
      return {
        msg: '未查询到商品',
        url: 'rest/ezscc/store/storageItemPagedForCartModel',
        param: {
          pageNo: 1,
          pageSize: 10,
          parameters: {},
          totalCount: 0,
          criteriaCode: 'ILNK_STORAGE_STORAGEITEM_BY_EPC',
        },
        method: 'post',
      }
    },
  },
  //扫码厂家原始条码查询的接口信息
  scanOriginAsyncGetDataOptions: {
    type: Object,
    // default: () => {
    //   return {
    //     msg: '未查询到商品',
    //     url: 'rest/ezscc/store/storageItemPagedForCartModel',
    //     param: {
    //       pageNo: 1,
    //       pageSize: 10,
    //       parameters: {},
    //       totalCount: 0,
    //       criteriaCode: 'ILNK_STORAGE_STORAGEITEM_BY_EPC',
    //     },
    //     method: 'post',
    //   }
    // },
  },
  scanOriginOrdinaryInfo: {
    type: Array,
    default: () => {
      return [
        {
          code: 'item#goodsStore#batchNumber',
          name: '生产批号',
        },
        {
          code: 'item#goodsStore#serialNumber',
          name: '序列号',
        },
        {
          code: 'item#goodsStore#periodBegin',
          name: '生产日期',
        },
        {
          code: 'item#goodsStore#periodEnd',
          name: '失效日期',
        },
        {
          code: 'cooperation#name',
          name: '货源供应商',
        },
        {
          code: 'refcode',
          name: '货源供应商单号',
        },
      ]
    },
  },
  scanOriginImportanceInfo: {
    type: Array,
    default: () => {
      return [
        {
          code: 'item#goodsInfo#code',
          name: '商品编码',
        },
        {
          code: 'item#goodsInfo#name',
          name: '商品名称',
        },
        {
          code: 'item#goodsInfo#model',
          name: '规格型号',
        },
      ]
    },
  },
  //是否需要转换
  isTransf: {
    type: Boolean,
    default: false,
  },
  //转换的内容
  transfContent: {
    type: Object,
    default: () => ({}),
  },
  //批量获取价格url
  batchPriceUrl: {
    type: String,
    default: null,
  },
  //取件选项url
  priceRangeUrl: {
    type: String,
    default: null,
  },
  //取价选项请求参数
  priceRangeParam: {
    type: Object,
    default: null,
  },
  //取件选项是否可编辑
  topSelectDisabled: {
    type: Boolean,
    default: false,
  },
  //获取价格默认值Url
  priceRangeDefaultUrl: {
    type: String,
    default: null,
  },
  //获取价格默认值参数
  priceRangeDefaultParam: {
    type: Object,
    default: null,
  },
  // 页面初始时，是否显示已选中项的仓库名
  ifGetSelectedRowOfWarehouseName: {
    type: Boolean,
    default: false,
  },
  pageSize: {
    type: Number,
    default: 30,
  },
  pageSizeOpts: {
    // 分页size 设置
    type: Array,
    default: () => [10, 20, 30, 40, 50, 100],
  },
  //优联是否需要带入表单信息
  isNeedOrderForm: {
    type: Boolean,
    default: false,
  },
  //是否删除多余属性
  isDeleteSessionParam: {
    type: Boolean,
    default: false,
  },
  // 扫码自定义序列号的标签名
  scanEpcLabel: {
    type: String,
    default: '自定义序列号扫码添加',
  },
  // 扫码厂家原始条码的标签名
  scanOriginLabel: {
    type: String,
    default: '厂商原始条码扫码添加',
  },
  // 扫码追溯码的标签名
  showTraceableCodeLabel: {
    type: String,
    default: '',
  },
  //控制表格顶部选择下拉disabled
  topSelectDisabledReq: {
    type: String,
    default: null,
  },
  // #6736，指定清除 firstParamLocalStorage 的属性(参数)
  clearfirstParamLocalStorageItem: { type: Object },
  // #7175，是否删除epc相同的明细行
  isDelSameEpc: { type: Boolean, default: false },
  // #8091，是否删除相同包的明细行
  isDelSamePackage: { type: Boolean, default: false },
  // #7199，根据选择的明细获取添加到下表明细的ids
  getAddItemsIdsUrl: { type: String, default: '' },
  addItemsIdsParam: { type: Object },
  errorRow: {
    type: Boolean,
    default: false,
  },
  errorRowExpression: String,
  //是否需要先决条件默认值
  isNeedOtherParam: {
    type: Boolean,
    default: false,
  },
  //先决条件默认值
  OtherFirstFormParam: {
    type: Object,
    default: null,
  },
  //表单是否进行验证
  isValidate: {
    type: Boolean,
    default: false,
  },
  // #38995，往下表添加明细数据的前置动作
  beforeAddItemsToBottom: {
    type: Function,
  },
  //我要采退重采 生成成功的两个单据的显示
  isShowDifferent: {
    type: Boolean,
    default: false,
  },
  //是否通过验证结果进行处理
  isResultRule: {
    type: Boolean,
    default: false,
  },
  // #8365 处理添加到明细的数据
  addItems: {
    type: Function,
  },
  //8695 最新的一条数据在最上面优联需要上下表 即越早添加的排在越后面
  isUnion: {
    type: Boolean,
    default: false,
  },
  //8778
  //8695  替换数据
  priceRangeDefaultParamValueKey: {
    type: String,
  },
  //8778
  //8695  替换数据
  priceRangeDefaultParamPathKey: {
    type: String,
  },
  //8695替换查询数据
  replaceSearachParameterValue: {
    type: String,
  },
  //8695替换查询数据
  replaceSearachParameterKey: {
    type: String,
  },
  topButtonKey: {
    type: String,
    default: 'TOP',
  },
  //特殊逻辑待处理-来自跟台收货通知单  预入仓库自定义显示   还有取值的问题
  isShowInwarehouse: {
    type: Boolean,
    default: false,
  },
  //特殊逻辑9967 需求 待处理-来自补货申请单   需要判断用户是否有其他参数
  isAddQueryParamsForCreat: {
    type: Boolean,
    default: false,
  },
}
